import React, {Component} from "react";

export class ColumnHelper extends Component {
    render() {
        return (
            <div className="column-description">
                <p>{this.props.description}</p>
            </div>
        )
    }
}